import { APIPropTypes, PropTypes, React, actions, connect, defaults } from 'imports';
import { Spinner, Tooltip } from '..';
import { RequestStatus } from 'utils/constants';
import { colorHash } from 'utils';
import './User.less';

export const AUTO_CURRENT_USER_ID = -1;
const ANONYMOUS_USER_ID = -2;

class User extends React.PureComponent {
    static get AUTO_CURRENT_USER_ID() {
        return AUTO_CURRENT_USER_ID;
    }

    static get propTypes() {
        return {
            userID: PropTypes.number,
            userName: PropTypes.string,

            session: APIPropTypes.SessionInformation.isRequired,
            users: APIPropTypes.networkArrayOf(APIPropTypes.UserLocal).isRequired,

            className: PropTypes.string,
            firstNameVisible: PropTypes.bool,
            lastNameVisible: PropTypes.bool,
            pictureVisible: PropTypes.bool,
            tooltipVisible: PropTypes.bool
        };
    }

    static get defaultProps() {
        return {
            userID: AUTO_CURRENT_USER_ID,
            userName: '',
            className: '',
            firstNameVisible: true,
            lastNameVisible: true,
            pictureVisible: true,
            tooltipVisible: true
        };
    }

    state = { user: null };

    static get contextTypes() {
        // works slightly faster than injectIntl
        return {
            intl: PropTypes.object
        };
    }

    componentWillMount() {
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.users.Custom.status === RequestStatus.UNSYNCED) {
            nextProps.dispatch(actions.loadAllUsers());
        }

        let user = null;

        if (nextProps.userName) {
            user = { ...defaults.UserLocal, ID: ANONYMOUS_USER_ID, FirstName: nextProps.userName };
        }
        else if (nextProps.users.Custom.status === RequestStatus.SUCCEEDED) {
            const userID = nextProps.userID === AUTO_CURRENT_USER_ID ? nextProps.session.UserID : nextProps.userID;
            user = nextProps.users.Data.getByID(userID);

            if (!user) {
                user = {
                    ...defaults.UserLocal,
                    ID: userID,
                    FirstName: this.context.intl.formatMessage({ id: 'common.unknown_user_first_name' }),
                    LastName: this.context.intl.formatMessage({ id: 'common.unknown_user_last_name' })
                };
            }
        }

        this.setState({ user });
    }

    render() {
        const
            { session, users, className, pictureVisible, firstNameVisible, lastNameVisible, tooltipVisible } = this.props,
            { user } = this.state,

            userID = this.props.userID === AUTO_CURRENT_USER_ID ? session.UserID : this.props.userID,
            isUnknownUser = session.IsTrialUnknownUser && userID === session.UserID;

        return (
            <div className={`user ${className}`}>
                {
                    pictureVisible ?
                        users.Custom.status === RequestStatus.SUCCEEDED ?
                            user.ProfileImageURI ?
                                <div className="userpic">
                                    <img src={user.ProfileImageURI} />
                                    {
                                        tooltipVisible && (!firstNameVisible || !lastNameVisible) ?
                                            <Tooltip><User {...this.props} pictureVisible={false} firstNameVisible lastNameVisible /></Tooltip> :
                                            null
                                    }
                                </div> :
                                <div className="userpic initials"
                                    style={{ backgroundColor: colorHash((this.props.userID ? user.ID : AUTO_CURRENT_USER_ID) + user.FirstName + user.LastName) }}
                                >
                                    {!this.props.userID || isUnknownUser ? '?' : `${user.FirstName[0] || ''}${user.LastName[0] || ''}` }
                                    {
                                        tooltipVisible && (!firstNameVisible || !lastNameVisible) ?
                                            <Tooltip><User {...this.props} pictureVisible={false} firstNameVisible lastNameVisible /></Tooltip> :
                                            null
                                    }
                                </div> :
                            <div className="userpic initials"><Spinner config={{ scale: 0.125 }} /></div> :
                        null
                }
                {
                    firstNameVisible || lastNameVisible ?
                        users.Custom.status === RequestStatus.SUCCEEDED ?
                            firstNameVisible && lastNameVisible ?
                                <span className="username">{`${user.FirstName} ${user.LastName}`.trim()}</span> :
                                firstNameVisible ?
                                    <span className="username">
                                        {user.FirstName}
                                        {
                                            tooltipVisible && !lastNameVisible ?
                                                <Tooltip><User {...this.props} pictureVisible={false} firstNameVisible lastNameVisible /></Tooltip> :
                                                null
                                        }
                                    </span> :
                                    lastNameVisible ?
                                        <span className="username">
                                            {user.LastName}
                                            {
                                                tooltipVisible && !firstNameVisible ?
                                                    <Tooltip><User {...this.props} pictureVisible={false} firstNameVisible lastNameVisible /></Tooltip> :
                                                    null
                                            }
                                        </span> :
                                        null :
                            !pictureVisible ?
                                <span className="username"><Spinner config={{ scale: 0.0625 }} /></span> :
                                null :
                        null
                }
            </div>
        );
    }
}

export default connect((state, ownProps) => ({
    users: ownProps.users || state.app.users
}))(User);
